import {CommandClause} from "./command_clause";
import {PsdkConst} from "../../types";
import {Command, DefaultCommand} from "./command";
import {Arg} from "../../args";

/**
 * Command builder
 */
export class Commander {

  /**
   * Command clauses
   * @private
   */
  private readonly clauses: Array<CommandClause>;
  private readonly _variable: Map<string, any>;

  private constructor() {
    this.clauses = [];
    this._variable = new Map();
  }

  /**
   * Make a commander
   */
  public static make(): Commander {
    return new Commander();
  }

  /**
   * Push a text command
   * @param command command
   * @param options Options: { newline: newline, charset: charset }
   */
  public pushText(command: string, options?: { newline?: boolean, charset?: string }): Commander {
    if (command.startsWith(PsdkConst.CRLF)) {
      command = command.substring(2);
    }
    const clause = CommandClause.text(command, options?.charset ?? PsdkConst.DEF_CHARSET);
    return this.pushClause(clause, options?.newline ?? PsdkConst.DEF_ENABLED_NEWLINE);
  }

  /**
   * Push binary command
   * @param command Command
   * @param newline Add new line for this command
   */
  public pushBinary(command: Uint8Array, newline?: boolean): Commander {
    const clause = CommandClause.binary(command);
    return this.pushClause(clause, newline ?? PsdkConst.DEF_ENABLED_NEWLINE);
  }

  /**
   * Push clause
   * @param clause Command clause object
   * @param newline Add new line for this command
   */
  public pushClause(clause: CommandClause, newline?: boolean): Commander {
    this.clauses.push(clause);
    if (newline ?? PsdkConst.DEF_ENABLED_NEWLINE) {
      this.clauses.push(CommandClause.newline());
    }
    return this;
  }

  /**
   * Push multiple clause
   * @param clauses
   */
  public pushClauses(clauses: Array<CommandClause>): Commander {
    clauses.forEach(item => this.pushClause(item, false));
    return this;
  }

  /**
   * Push arg
   * @param arg arg
   */
  public pushArg(arg: Arg<any>) {
    this.pushClauses(arg.clauses());
    return this;
  }

  /**
   * Add newline
   */
  public newline(): Commander {
    const clause = CommandClause.newline();
    return this.pushClause(clause, false);
  }

  /**
   * Add a new variable
   * @param name name
   * @param value value
   */
  public variable(name: string, value: any): Commander {
    this._variable.set(name, value);
    return this;
  }

  /**
   * Clear all commands
   */
  public clear(): Commander {
    this.clauses.splice(0, this.clauses.length);
    this._variable.clear();
    return this;
  }

  /**
   * Get command
   */
  public command(): Command {
    return new DefaultCommand(this.clauses, this._variable);
  }

}
